import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {getCandidateSource} from '/component/partial/report/DateAddedComponent/DateAddedComponent.util';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './CandidateSource.style';

interface CandidateSourceProps {
  item: {
    source: string;
    [key: string]: any;
  };
}
export const CandidateSource: React.FC<CandidateSourceProps> = ({
  item = {},
}) => {
  const source = get(item, 'source', '');
  const displaySource = getCandidateSource(source)?.name || 'Leads Pool';

  return (
    <Text
      variant="button"
      style={styles.sourceStyle}
      allowFontScaling
      maxFontSizeMultiplier={2}
      {...testProperties(Reports.reportCandidateSource)}>
      from {displaySource}
    </Text>
  );
};

export default withTranslation('report.record.CandidateSource')(
  CandidateSource,
);
